/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 电子钱包快速支付
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  walletPaymentDTO: payment.WalletPaymentDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/payment/wallet`,
    data: walletPaymentDTO,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
